export default class Icons {
  static load(path) {
    window.iconsPath = window.iconsPath || '/';
    
    let fullPath = path || (window.iconsPath.endsWith('/') ? window.iconsPath : window.iconsPath + '/') + 'assets/icons.svg';

    if (!fullPath.startsWith('http') && !fullPath.startsWith('/')) {
      fullPath = '/' + fullPath;
    }

    fetch(fullPath)
      .then(res => {
        if (!res.ok) throw new Error('Le fichier icons est introuvable.');
        return res.text();
      })
      .then(data => {
        const container = document.createElement('div');
        container.style.display = 'none';
        container.innerHTML = data;
        document.body.appendChild(container);
      })
      .catch(error => {
        console.error(`Une erreur est survenue : ${error.message}`);
      });
  }
}